import type { PermissionsStatus, OriginPermission } from '@models/profile/useProfilePermission';

/**
 * 判断是否拥有权限
 * @param {Array<string|number>} permissions - 要判断的权限列表 name 集合
 */
const includePermissionWithAccountInfo = function (
    permissions: Array<string> = [],
    permissionConfig: OriginPermission
): boolean {
    if (!permissionConfig) return false;
    if (!permissions.length) return true;

    return permissions.some(name => {
        const pInfo = permissionConfig.permissionDict?.find(item => item.name === name || item.id === name);
        if (pInfo) {
            const status: PermissionsStatus = pInfo.status;

            return status === -1
                ? false
                : status === 1 || permissionConfig.permissionIdList.includes(pInfo.id);
        }
        return true;
    });
};

export default {
    includePermissionWithAccountInfo
};
